import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export type AttendeeUpdateEntry = {
  userUuid: string
  status: 'attended' | 'not-attended' | 'unknown'
  dateUuid: string

  // [bookingUuid = null] happens when the user's attendance status
  // was not yet stored in the attendees' table. This is a
  // normal case for the first time form submission.
  bookingUuid: string | null
}

export default function useUpdateAttendees() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: { dateUuid: string; entries: AttendeeUpdateEntry[] }) => {
      await api.put(`scheduled-course/event-date/${encodeURIComponent(data.dateUuid)}/attendees`, {
        entries: data.entries,
      })

      invalidate.courses()
    },
  })
}
